module.exports = __webpack_public_path__ + "img/Connect Graphic 2.65161580.png";